import { render, staticRenderFns } from "./HeaderV3.vue?vue&type=template&id=271c8fc2&scoped=true&"
import script from "./HeaderV3.vue?vue&type=script&lang=js&"
export * from "./HeaderV3.vue?vue&type=script&lang=js&"
import style0 from "./HeaderV3.vue?vue&type=style&index=0&id=271c8fc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271c8fc2",
  null
  
)

export default component.exports